import api from "@/router/api"

export default {
    getAllMaintenanceTaskTypes({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesMaintenanceTaskTypesVhe.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_MAINTENANCE_TASK_TYPES', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener el resultado',
                })
            })
        })
    },
}
